import { Filter, FilterType, ISystemAndUniConfig, TagType, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';
import { orderBy, uniqBy } from 'lodash';

const studentsEmptyTagId = 'None';

type Mode = 'Offer' | 'Intake';
const getOfferOrIntakeMode = (mode?: boolean): Mode => {
  return mode ? 'Offer' : 'Intake';
};

const parseTags = (tags: Array<{ label: string; value: string; type: string }>, _mode: Mode) => {
  const allTagOptions: { label: string; value: string }[] = [];

  tags.forEach((tag: { label: string; value: string; type: string }) => {
    const hasLabel = tag?.label && tag.label.length;
    const notProgrammatic = tag.type !== TagType.PROGRAMMABLE;
    if (hasLabel && notProgrammatic) {
      allTagOptions.push({
        label: tag?.label,
        value: tag?.value,
      });
    }
  });

  const options = [
    ...allTagOptions,
    {
      label: 'None',
      value: studentsEmptyTagId,
    },
  ];

  return options;
};

interface PathwayConfig extends ISystemAndUniConfig {
  multiOfferStudentFlow?: boolean;
}

const key = FilterKey.TAGS;
export const getTagsFilter = ({
  activeFilters,
  config,
  userRole,
  filterOptions,
}: IGetFilterGroupsProps): Filter | null => {
  const canFilterTagsStatus = hasPerm(userRole || UserRole.Unknown, P.FILTER_TAGS_STATUS);
  const tagsFilterOptions = filterOptions?.tag || [];
  if (!canFilterTagsStatus) {
    return null;
  }
  const pathwayConfig = config as PathwayConfig;

  // tags coming from the backend in some cases are with the same id/value but different type
  const tagsFilterOptionsUnique = uniqBy(tagsFilterOptions, 'value');

  const allTags = parseTags(tagsFilterOptionsUnique || [], getOfferOrIntakeMode(pathwayConfig.multiOfferStudentFlow));

  const filters = activeFilters[key] ?? [];

  const options = allTags.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Tags',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
